export default "__VITE_ASSET__Dt24ZLnf__"